<app-receipt
  [display_columns]="display_columns"
  [staged_receipts]="staged_receipts"
  [sse_name]="'AccountReturn'"
  [upload_field_text]="'receipt.uploadAccountReturn' | translate"
  [validation_schema]="validation_schema"
  [upload_handler]="upload_files_client"
  [lookupPermanent]="look_today"
  [wasm_split_pattern]="wasm_split_pattern"
  [callme]="lookup_all"
  [available_filters]="available_filters"
  [get_paginated_data]="get_paginated_data"
></app-receipt>
